/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eg_The_Sovereign_CollectionInputs */

const en_eg_the_sovereign_collection = /** @type {(inputs: Eg_The_Sovereign_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. The Sovereign Collection`)
};

const es_eg_the_sovereign_collection = /** @type {(inputs: Eg_The_Sovereign_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. The Sovereign Collection`)
};

const fr_eg_the_sovereign_collection = /** @type {(inputs: Eg_The_Sovereign_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. The Sovereign Collection`)
};

const de_eg_the_sovereign_collection = /** @type {(inputs: Eg_The_Sovereign_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. The Sovereign Collection`)
};

const ja_eg_the_sovereign_collection = /** @type {(inputs: Eg_The_Sovereign_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例: The Sovereign Collection`)
};

const zh_eg_the_sovereign_collection = /** @type {(inputs: Eg_The_Sovereign_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如：The Sovereign Collection`)
};

const ar_eg_the_sovereign_collection = /** @type {(inputs: Eg_The_Sovereign_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مثال: The Sovereign Collection`)
};

const id_eg_the_sovereign_collection = /** @type {(inputs: Eg_The_Sovereign_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mis. Koleksi Sovereign`)
};

const it_eg_the_sovereign_collection = /** @type {(inputs: Eg_The_Sovereign_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. The Sovereign Collection`)
};

const ru_eg_the_sovereign_collection = /** @type {(inputs: Eg_The_Sovereign_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`например, The Sovereign Collection`)
};

const pt_eg_the_sovereign_collection = /** @type {(inputs: Eg_The_Sovereign_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. The Sovereign Collection`)
};

const ko_eg_the_sovereign_collection = /** @type {(inputs: Eg_The_Sovereign_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예: 더 소버린 컬렉션`)
};

/**
* | output |
* | --- |
* | "e.g. The Sovereign Collection" |
*
* @param {Eg_The_Sovereign_CollectionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const eg_the_sovereign_collection = /** @type {((inputs?: Eg_The_Sovereign_CollectionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eg_The_Sovereign_CollectionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eg_the_sovereign_collection(inputs)
	if (locale === "es") return es_eg_the_sovereign_collection(inputs)
	if (locale === "fr") return fr_eg_the_sovereign_collection(inputs)
	if (locale === "de") return de_eg_the_sovereign_collection(inputs)
	if (locale === "ja") return ja_eg_the_sovereign_collection(inputs)
	if (locale === "zh") return zh_eg_the_sovereign_collection(inputs)
	if (locale === "ar") return ar_eg_the_sovereign_collection(inputs)
	if (locale === "id") return id_eg_the_sovereign_collection(inputs)
	if (locale === "it") return it_eg_the_sovereign_collection(inputs)
	if (locale === "ru") return ru_eg_the_sovereign_collection(inputs)
	if (locale === "pt") return pt_eg_the_sovereign_collection(inputs)
	return ko_eg_the_sovereign_collection(inputs)
});